module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: _vm.classes,
    attrs: {
      "href": _vm.href,
      "disabled": _vm.disabled || _vm.loading
    },
    on: {
      "click": _vm._click
    }
  }, [_c('animated-swing', [(!_vm.loading) ? _c('span', {
    key: "slot"
  }, [_vm._t("default")], 2) : _c('span', {
    key: "loading"
  }, [_vm._v(_vm._s(_vm.loadingText))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1578c890"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/link-btn.vue
// module id = 670
// module chunks = 85